import React from "react";
import useCanonical from "../../helper/useCanonical";
import termsCondition from "../../assets/other/terms-conditions.jpeg";

const TermsAndConditions = () => {
  useCanonical(
    "/terms-and-condition",
    "Terms & Conditions | Sarcasm",
    "Review Sarcasm's Terms & Conditions covering website usage, content policies, intellectual property, user responsibilities, and legal information."
  );
  return (
    <>
      <section className="about-wrap-layout-1 space-top-60 space-bottom-60 space-top-md-30 space-bottom-md-30 bg-color-selago transition-default">
        <div className="container">
          <div className="row g-4">
            <div className="col-lg-4 order-lg-2">
              <div className="about-box-layout-1 box-border-dark-1-fixed radius-default">
                <div className="figure-holder radius-medium img-height-100">
                  <img src={termsCondition} />
                </div>
              </div>
            </div>
            <div className="col-lg-8 order-lg-1">
              <div className="about-box-layout-1 pe-lg-5">
                <div className="content-holder">
                  <h2 className="entry-title color-dark-1-fixed">
                    Terms and Conditions
                  </h2>
                  <p className="entry-description color-dark-1-fixed">
                    Welcome to Sarcasm.co. These Terms and Conditions govern
                    your access to and use of our website located at{" "}
                    <a
                      href="https://www.sarcasm.co"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      https://www.sarcasm.co
                    </a>
                    . By accessing or using this Website, you agree to be bound
                    by these Terms and our Privacy Policy.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="terms-container space-top-60 space-bottom-30 space-top-md-30 space-bottom-md-30">
        <section className="terms-section">
          <h2>1. Use of the Website</h2>
          <p>
            Sarcasm.co offers articles, news, and commentary on topics including
            marketing, sports, entertainment, and related subjects. You may use
            the Website for personal, non-commercial purposes only. You agree
            not to use the Website for any unlawful or prohibited activity. You
            must be at least 13 years old to use this Website.
          </p>
        </section>

        <section className="terms-section">
          <h2>2. Intellectual Property</h2>
          <p>
            All content on Sarcasm.co, including text, images, graphics, logos,
            videos, and design, is the property of Sarcasm.co or its content
            creators and protected by applicable intellectual property laws. You
            may not reproduce, distribute, modify, or republish any content from
            the Website without prior written permission.
          </p>
        </section>

        <section className="terms-section">
          <h2>3. User Submissions</h2>
          <p>
            By submitting comments, feedback, or any content to Sarcasm.co, you
            grant us a non-exclusive, worldwide, royalty-free license to use,
            reproduce, and display your content in connection with the Website.
            You agree not to post content that is defamatory, obscene,
            offensive, or otherwise violates any law or the rights of others.
          </p>
        </section>

        <section className="terms-section">
          <h2>4. Privacy</h2>
          <p>
            Your use of the Website is subject to our Privacy Policy, which
            outlines how we collect, use, and protect your information. By using
            this Website, you consent to the practices described in the Privacy
            Policy.
          </p>
        </section>

        <section className="terms-section">
          <h2>5. Cookies and Tracking</h2>
          <p>
            Sarcasm.co uses cookies and similar technologies to enhance your
            browsing experience and serve personalized content and ads. You may
            manage or disable cookies in your browser settings, though this may
            affect certain features of the Website.
          </p>
        </section>

        <section className="terms-section">
          <h2>6. Third-Party Links and Content</h2>
          <p>
            The Website may include links to external websites and embedded
            third-party content (e.g., videos, tweets). These are provided for
            your convenience. We are not responsible for the content, policies,
            or practices of any third-party sites. Please review their terms and
            privacy policies independently.
          </p>
        </section>

        <section className="terms-section">
          <h2>7. Disclaimer of Warranties</h2>
          <p>
            Sarcasm.co is provided on an "as is" and "as available" basis. We do
            not warrant that the Website will be error-free, uninterrupted, or
            secure. All content is for informational purposes only and does not
            constitute professional advice.
          </p>
        </section>

        <section className="terms-section">
          <h2>8. Limitation of Liability</h2>
          <p>
            To the fullest extent permitted by law, Sarcasm.co and its
            affiliates shall not be liable for any indirect, incidental,
            special, or consequential damages arising from your use of, or
            inability to use, the Website or its content.
          </p>
        </section>

        <section className="terms-section">
          <h2>9. Termination</h2>
          <p>
            We reserve the right to suspend or terminate your access to the
            Website at any time, without notice, for any reason, including
            violation of these Terms of Use.
          </p>
        </section>

        <section className="terms-section">
          <h2>10. Changes to Terms</h2>
          <p>
            We may update these Terms from time to time. Any changes will be
            posted on this page with an updated effective date. Continued use of
            the Website after such updates constitutes acceptance of the revised
            Terms.
          </p>
        </section>

        <section className="terms-section">
          <h2>11. Governing Law</h2>
          <p>
            These Terms shall be governed by and construed under the laws of
            India, without regard to its conflict of law principles. Any
            disputes shall be subject to the exclusive jurisdiction of the
            courts in Indore.
          </p>
        </section>
      </div>
    </>
  );
};

export default TermsAndConditions;
